export interface DoodAddressComponent {
  types: string[];
  long_name: string;
  short_name: string;
}

export interface DoodAddressLocationModel {
  lat?: number;
  lng?: number;
  address_components?: DoodAddressComponent[];
}

export interface DoodLocationModel extends DoodAddressLocationModel {
  address?: string;
  instructions?: string | null;
}

export enum DoodWantedAtType {
  asap = 'asap',
  later = 'later',
}

export interface DoodLocationParameters {
  deliveryLat: number;
  deliveryLng: number;
  deliveryCity: string;
  deliveryCountry: string;
  deliveryPostalCode: string;
  deliveryStreetAddress: string;
  deliveryInstructions: string;
}
